// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","p":"Footer_p__iHp7l","author":"Footer_author__OoSZf"};